import {
  Box,
  Chip,
  Divider,
  Rating,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalButton from "../button";
import Counter from "../counterButton";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { setCartData } from "../../lib/redux/slices/cartSlice";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from "react-router-dom";
import { CURRENCY } from "../../lib/variables";
import { t } from "i18next";
import ReactGA from "react-ga4";

const ProductInfo = ({ productDetail }) => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { palette } = useTheme();
  // Fix State
  const hasBrand = productDetail?.brand;
  // States
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeColor, setSelectedSizeColor] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState(null);

  const [selectedQty, setSelectedQty] = useState(1);
  const [isSpecksShow, setIsSpecksShow] = useState(false);
  const [isInStock, setIsInStock] = useState(false);
  const [disableCounters, setDisAbleCounters] = useState({
    add: false,
    subtract: true,
  });

  // Redux states
  const { cartData } = useSelector((state) => state.cartReducer);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  // conditional states
  let pprice =
    productDetail?.discount > 0
      ? productDetail?.discount
      : productDetail?.price;

  let pdiscount = productDetail?.discount > 0 ? productDetail?.price : null;

  useEffect(() => {
    if (productDetail) {
      let { color, size, sizeWithColor, quantity, weigth } = productDetail;
      if (color.length > 0) {
        for (let index = 0; index < color?.length; index++) {
          if (color[index].quantity > 0) {
            setSelectedColor(color[index]);
            setIsInStock(true);
            break;
          }
        }
      }

      if (size?.length > 0) {
        for (let index = 0; index < size?.length; index++) {
          if (size[index].quantity > 0) {
            setSelectedSize(size[index]);
            setIsInStock(true);
            break;
          }
        }
      }

      if (weigth?.length > 0) {
        for (let index = 0; index < weigth?.length; index++) {
          if (weigth[index].quantity > 0) {
            setSelectedWeight(weigth[index]);
            setIsInStock(true);
            break;
          }
        }
      }

      if (sizeWithColor?.length > 0) {
        outerLoop: for (let index = 0; index < sizeWithColor?.length; index++) {
          for (
            let jindex = 0;
            jindex < sizeWithColor[index].colors?.length;
            jindex++
          ) {
            if (sizeWithColor[index].colors[jindex].quantity > 0) {
              setSelectedSizeColor(sizeWithColor[index]);
              setSelectedColor(sizeWithColor[index].colors[jindex]);
              setIsInStock(true);

              break outerLoop;
            }
          }
        }
      }

      if (quantity > 0) {
        setIsInStock(true);
      }
    }
  }, [productDetail]);

  const handleDecreaseQty = () => {
    if (selectedQty == 1) {
      return setDisAbleCounters((pre) => ({ ...pre, subtract: true }));
    }
    setSelectedQty((pre) => pre - 1);
    setDisAbleCounters((pre) => ({ ...pre, add: false }));
  };

  const handleIncreaseQty = (product) => {
    if (product.quantity > 0) {
      if (selectedQty == product.quantity) {
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
        setSelectedQty((pre) => pre + 1);
      }
    }

    if (product?.size?.length > 0 && selectedSize !== null) {
      if (selectedQty === selectedSize.quantity) {
        // alert(`Max quantity reached for size ${selectedSize.name}`);
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
        setSelectedQty((pre) => pre + 1);
      }
    }

    if (product?.weigth?.length > 0 && selectedWeight !== null) {
      if (selectedQty === selectedWeight.quantity) {
        // alert(`Max quantity reached for size ${selectedSize.name}`);
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
        setSelectedQty((pre) => pre + 1);
      }
    }

    if (product?.color?.length > 0 && selectedColor !== null) {
      if (selectedQty === selectedColor.quantity) {
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
        setSelectedQty((pre) => pre + 1);
      }
    }

    if (product?.sizeWithColor?.length > 0 && selectedSizeColor !== null) {
      if (!selectedColor) {
        return showSnackbar(t("selectColorToIncreaseQuantity"), "error");
      }

      if (selectedQty === selectedColor.quantity) {
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        setDisAbleCounters((pre) => ({ ...pre, subtract: false }));
        setSelectedQty((pre) => pre + 1);
      }
    }
  };

  const handleAddToCart = (product) => {
    // selectedQty: tempCart[existingProductIndex].selectedQty + selectedQty,
    let tempCart = [...cartData];

    if (product.quantity > 0) {
      const existingProductIndex = tempCart.findIndex(
        (item) => item._id === productDetail._id
      );

      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty,
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        ReactGA.event({
          category: "Ecommerce",
          action: "Add to Cart",
          label: productDetail.name.en,
          value: 1,
        });
        tempCart.push({ ...productDetail, selectedQty });
      }
    }

    if (product?.size?.length > 0) {
      let existingProductIndex = tempCart.findIndex(
        (itemmm) =>
          itemmm._id == productDetail._id &&
          itemmm.selectedSize.name == selectedSize.name
      );
      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty,
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        tempCart.push({
          ...productDetail,
          selectedQty,
          selectedSize,
        });
      }
    }

    if (product?.weigth?.length > 0) {
      let existingProductIndex = tempCart.findIndex(
        (itemmm) =>
          itemmm._id == productDetail._id &&
          itemmm.selectedWeight.name == selectedWeight.name
      );
      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty,
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        tempCart.push({
          ...productDetail,
          selectedQty,
          selectedWeight,
          price: selectedWeight.price,
          finalPrice: selectedWeight.price,
        });
      }
    }

    if (product?.color?.length > 0) {
      let existingProductIndex = tempCart.findIndex(
        (itemmm) =>
          itemmm._id == product._id &&
          itemmm.selectedColor.color == selectedColor.color
      );
      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty,
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        tempCart.push({
          ...product,
          selectedQty,
          selectedColor,
        });
      }
    }

    if (product?.sizeWithColor?.length > 0) {
      if (!selectedColor) {
        return showSnackbar(t("selectAvailableColor"), "error");
      }
      let existingProductIndex = tempCart.findIndex(
        (itemmm) =>
          itemmm._id == product._id &&
          itemmm.selectedSizeWithColor.size == selectedSizeColor.name &&
          itemmm.selectedSizeWithColor.color == selectedColor.color
      );
      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty,
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        let newObjjj = {
          ...product,
          selectedQty,
          selectedSizeWithColor: {
            size: selectedSizeColor?.name,
            color: selectedColor?.color,
            colorName: selectedColor.colorName,
            quantity: selectedColor?.quantity,
          },
        };
        tempCart.push(newObjjj);
      }
    }
    localStorage.setItem("cart-data", JSON.stringify(tempCart));
    dispatch(setCartData(tempCart));
    showSnackbar(t("productAddedToCart"));
    navigate("/");
  };

  const renderSize = (productDetail) => {
    return (
      <Stack direction="row" alignItems={"center"} gap={"15px"}>
        {productDetail?.size?.map((val, index) => {
          const selected =
            selectedSize !== null && selectedSize?.name === val?.name;
          return (
            <Box
              key={index}
              position={"relative"}
              border={`2px solid ${
                selected ? palette.primary.main : "#8d8d8d"
              }`}
              height={35}
              width={35}
              borderRadius={1}
              bgcolor={selected ? "primary.main" : "text.white"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                cursor: val.quantity === 0 ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (val.quantity !== 0) {
                  setSelectedSize(val);
                  setSelectedQty(1);
                  setDisAbleCounters((pre) => ({ ...pre, add: false }));
                }
              }}
            >
              <Box position={"absolute"} top={0}>
                {val.quantity === 0 && (
                  <CloseRoundedIcon
                    htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                    sx={{ fontSize: "2rem" }}
                  />
                )}
              </Box>
              <Typography
                variant={"body1"}
                color={selected ? "text.white" : "text.black"}
                sx={{
                  opacity: val.quantity === 0 ? 0.5 : 1,
                }}
              >
                {val?.name}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    );
  };

  const renderColors = (color) => {
    return (
      <Stack direction="row" alignItems={"center"} gap={"5px"}>
        {color?.map((val, index) => {
          const selected =
            selectedColor !== null && selectedColor.color === val.color;

          return (
            <Box
              key={index}
              border={`2px solid ${selected ? palette.text.black : val.color}`}
              borderRadius={"100%"}
              sx={{
                cursor: val.quantity === 0 ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (val.quantity !== 0) {
                  setSelectedColor(val);
                  setSelectedQty(1);
                  setDisAbleCounters((pre) => ({ ...pre, add: false }));
                }
              }}
            >
              <Box
                key={index}
                border={`2px solid ${selected ? palette.text.white : val}`}
                height={20}
                width={20}
                borderRadius={"100%"}
                bgcolor={val?.color}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {val.quantity === 0 && (
                  <CloseRoundedIcon
                    htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                    sx={{ fontSize: "1.3rem" }}
                  />
                )}
              </Box>
            </Box>
          );
        })}
      </Stack>
    );
  };

  const renderSizesWithColor = () => {
    return (
      <Stack direction="row" alignItems={"center"} gap={"15px"}>
        {productDetail?.sizeWithColor?.map((val, index) => {
          const selected =
            selectedSizeColor !== null && selectedSizeColor.name === val.name;

          // Check if all colors have zero quantity
          const allColorsUnavailable = val.colors.every(
            (color) => color.quantity === 0
          );

          return (
            <Box
              key={index}
              position={"relative"}
              border={`2px solid ${
                selected ? palette.primary.main : "#8d8d8d"
              }`}
              height={35}
              width={35}
              borderRadius={1}
              bgcolor={selected ? "primary.main" : "text.white"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                cursor: allColorsUnavailable ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!allColorsUnavailable) {
                  setSelectedSizeColor(val);
                  setDisAbleCounters((pre) => ({ ...pre, add: false }));
                  setSelectedQty(1);
                  setSelectedColor(null);
                }
              }}
            >
              {allColorsUnavailable && (
                <Box position={"absolute"} top={0}>
                  <CloseRoundedIcon
                    htmlColor={"red"}
                    sx={{ fontSize: "2rem" }}
                  />
                </Box>
              )}
              <Typography
                variant={"body1"}
                color={selected ? "text.white" : "text.black"}
                sx={{
                  opacity: allColorsUnavailable ? 0.5 : 1,
                }}
              >
                {val?.name}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    );
  };

  const renderWeights = (productDetail) => {
    return (
      <Stack direction="row" alignItems={"center"} gap={"15px"}>
        {productDetail?.weigth?.map((val, index) => {
          const selected =
            selectedWeight !== null && selectedWeight?.name === val?.name;
          return (
            <Box
              key={index}
              px={1}
              position={"relative"}
              border={`2px solid ${
                selected ? palette.primary.main : "#8d8d8d"
              }`}
              height={35}
              width={"auto"}
              borderRadius={1}
              bgcolor={selected ? "primary.main" : "text.white"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                cursor: val.quantity === 0 ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (val.quantity !== 0) {
                  setSelectedWeight(val);
                  setSelectedQty(1);
                  setDisAbleCounters((pre) => ({ ...pre, add: false }));
                }
              }}
            >
              <Box position={"absolute"} top={0}>
                {val.quantity === 0 && (
                  <CloseRoundedIcon
                    htmlColor={val.color === "#ff1111" ? "#ff1111" : "red"}
                    sx={{ fontSize: "2rem" }}
                  />
                )}
              </Box>
              <Typography
                variant={"body1"}
                color={selected ? "text.white" : "text.black"}
                sx={{
                  opacity: val.quantity === 0 ? 0.5 : 1,
                }}
              >
                {val?.name}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    );
  };

  const renderStockChip = () => {
    return (
      <Chip
        label={isInStock ? t("inStock") : t("outOfStock")}
        sx={{
          background: isInStock
            ? "linear-gradient(45deg, #00C853, #69F0AE)"
            : "linear-gradient(45deg, #FF3D00, #FF7043)",
          color: "#ffffff",
          fontWeight: "bold",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          borderRadius: "4px",
          padding: "0 8px",
          overflow: "hidden",
          textTransform: "uppercase",
        }}
      />
    );
  };

  return (
    <Stack>
      <Stack spacing={1}>
        <Typography
          variant="body1"
          fontWeight={500}
          textTransform={"capitalize"}
        >
          {t("brand")} :{" "}
          <span style={{ fontWeight: 400 }}>
            {hasBrand ? productDetail.brand : "No Brand"}
          </span>
        </Typography>

        <Stack gap={2} direction={"row"} alignItems={"center"}>
          <Typography
            variant="body1"
            fontWeight={500}
            textTransform={"capitalize"}
          >
            {t("availability")} :
          </Typography>
          {renderStockChip()}
        </Stack>
        <Typography variant="h6" fontWeight={500}>
          {productDetail?.name[currentLanguage]}
        </Typography>
        <Rating
          // defaultValue={5}
          readOnly
          value={productDetail?.rating}
          sx={{
            "&.MuiRating-root": {
              color: "text.orangeRed",
            },
          }}
        />
        <Typography>{productDetail?.description[currentLanguage]}</Typography>

        <Divider sx={{ my: "1.5rem" }} />
        {/* product include sizes */}
        {productDetail?.size?.length > 0 ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={"15px"}
            m={"16px 0"}
          >
            <Typography variant="body1" fontWeight={500}>
              {t("size")}:
            </Typography>
            {renderSize(productDetail)}
          </Stack>
        ) : null}
        {/* product include weights */}
        {productDetail?.weigth?.length > 0 ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={"15px"}
            m={"16px 0"}
          >
            <Typography variant="body1" fontWeight={500}>
              {t("weight")}:
            </Typography>
            {renderWeights(productDetail)}
          </Stack>
        ) : null}

        {/* product include sizes with colors */}
        {productDetail?.sizeWithColor?.length > 0 ? (
          <Stack direction={"row"} alignItems={"center"} gap={"10px"}>
            <Typography variant="body1" fontWeight={500}>
              {t("size")}:
            </Typography>
            {renderSizesWithColor(productDetail)}
          </Stack>
        ) : null}
        {selectedSizeColor !== null ? (
          <Stack direction={"row"} alignItems={"center"} gap={"10px"} mt={1.5}>
            <Typography variant="body1" fontWeight={500}>
              {t("colors")}:
            </Typography>
            {renderColors(selectedSizeColor?.colors)}
          </Stack>
        ) : null}

        {/* product include colors */}
        {productDetail?.color?.length > 0 ? (
          <Stack direction={"row"} alignItems={"center"} gap={"10px"}>
            <Typography variant="body1" fontWeight={500}>
              {t("colors")}:
            </Typography>
            {renderColors(productDetail?.color)}
          </Stack>
        ) : null}

        {productDetail?.type !== "Food" &&
          productDetail?.weigth?.length === 0 && (
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Typography variant="h6" fontWeight={500}>
                {`${CURRENCY} ${pprice}`}
              </Typography>
              {pdiscount > 0 && (
                <Typography
                  variant="body1"
                  color={"text.gunmetal"}
                  sx={{ textDecoration: "line-through" }}
                >
                  {`${CURRENCY} ${pdiscount}`}
                </Typography>
              )}
            </Stack>
          )}

        {productDetail?.type == "Food" && productDetail?.weigth?.length > 0 && (
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <Typography variant="h6" fontWeight={500}>
              {`${CURRENCY} ${selectedWeight?.price || 0}`}
            </Typography>
          </Stack>
        )}

        <Stack
          mt={4}
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          gap={1}
        >
          <Counter
            value={selectedQty}
            handleDecreaseQty={handleDecreaseQty}
            handleIncreaseQty={() => handleIncreaseQty(productDetail)}
            disbleCounters={disableCounters}
          />
          {/* <GlobalButton
            btnText={"Buy Now"}
            disabled={!isInStock}
            styleProps={{
              backgroundColor: "text.orangeRed",
              width: "100%",
              height: 50,
              borderRadius: 0,
              fontSize: "1rem",
            }}
          /> */}
          <GlobalButton
            btnText={"addCart"}
            // variant={"outlined"}
            handleClickBtn={() => handleAddToCart(productDetail)}
            disabled={!isInStock}
            styleProps={{
              backgroundColor: "text.orangeRed",
              width: "100%",
              height: 50,
              borderRadius: 0,
              fontSize: "1rem",
            }}
            // styleProps={{
            //   width: "100%",
            //   height: 50,
            //   borderRadius: 0,
            //   fontSize: "1rem",
            //   borderColor: "text.orangeRed",
            //   color: "text.orangeRed",
            //   boxShadow: "none",
            // }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ProductInfo;
